import React, { Suspense } from "react"

import useContainer from "../../use-container"

const IncentiveEmailV2 = React.lazy(() => import("./incentive-email-v2"))

function IncentiveEmailModal({ active, onClose }) {
  const container = useContainer()

  return active ? (
    <Suspense fallback={<div />}>
      <IncentiveEmailV2 id={container.id} onClose={onClose} />
    </Suspense>
  ) : null
}

export default IncentiveEmailModal
